


























































import Vue from "vue";
import TableComplement from "@/components/Table/Complement/TableComplement.vue";
import CardTitle from "@/components/Text/Card/CardTitle.vue";
// import OnlineSurveysCard from "@/components/Page/Survey/OnlineSurveysCard.vue";
import SurveyTypeCard from "@/components/Page/Survey/SurveyTypeCard.vue";
import SurveysTable from "@/components/Table/Surveys/SurveysTable.vue";
import SurveysFilter from "@/components/Table/Surveys/SurveysFilter.vue";
import { SurveyFilterName } from "@/types/types";
import SurveyCreateModal from "@/components/Modal/Survey/SurveyCreateModal.vue";
import ToastNotification from "@/components/Modal/Toast/Toast.vue";
import { store } from "@/store/store";
import Utils from "@/utils/utils";
import Csv from "@/plugins/csv";
import { Survey } from "@/store/modules/Survey/interface";

// interface DeviceData {
//   selected: Array<string>;
//   filter_should_be_displayed: boolean;
//   filters: SurveyFilters;
//   should_display_create_modal: boolean;
//   survey_data: any;
// }

export default Vue.extend({
  name: "Survey",
  components: {
    CardTitle,
    TableComplement,
    // OnlineSurveysCard,
    SurveyTypeCard,
    SurveysTable,
    SurveysFilter,
    SurveyCreateModal,
    ToastNotification
  },
  data(): any {
    return {
      selected: [],
      filter_should_be_displayed: false,
      should_display_create_modal: false,
      should_display_toast: false,
      survey_data: null,
      filters: { active: "", id_budget: "", survey_name: "", type: "", agence: "" },
      toast: { type: "INFO", title: "", content: "" }
    };
  },
  methods: {
    clearSelected(): void {
      this.selected = [];
    },
    onSelectChange(_ids: Array<string>): void {
      this.selected = _ids;
    },
    shouldDisplayFilterPanel(): void {
      this.filter_should_be_displayed = !this.filter_should_be_displayed;
    },
    onFilterChange(filter: { type: SurveyFilterName; value: string }): void {
      this.filters[filter.type] = filter.value;
    },
    clearFilter(): void {
      this.filters = { active: "", id_budget: "", survey_name: "", type: "", agence: "" };
    },
    onClose(): void {
      this.should_display_create_modal = false;
      this.survey_data = null;
    },
    shouldDisplayCreateModal(): void {
      this.should_display_create_modal = true;
    },
    shouldDisplayUpdateModal(_id: string): void {
      this.survey_data = { ...store.getters.SURVEY_BY_ID[_id] };
      this.survey_data.start_date = Utils.transformDateToYMD(this.survey_data.start_date, "-");
      this.survey_data.end_date = Utils.transformDateToYMD(this.survey_data.end_date, "-");
      this.should_display_create_modal = true;
    },
    shouldDisplayToastNotification(toast_data: any): void {
      this.toast = toast_data;
      this.should_display_toast = true;
      setTimeout(this.shouldCloseToastNotification, 2000);
    },
    shouldCloseToastNotification(): void {
      this.should_display_toast = false;
    },
    downloadCsv(): void {
      const selected = this.selected.length === 0 ? store.getters.SURVEY_ALL_ID : this.selected;
      const headers = ["id_budget", "agence", "name_survey", "type", "user", "active", "start_date", "end_date"];
      const content = selected.map((survey_id: string) => {
        let survey = { ...store.getters.SURVEY_BY_ID[survey_id] };
        survey.user = store.getters.USER_BY_ID[survey.user].mail;
        survey.agence = store.getters.AGENCE_BY_ID[survey.agence].name;
        survey.start_date = Utils.transformDateToYMD(survey.start_date);
        survey.end_date = Utils.transformDateToYMD(survey.end_date);
        return survey;
      });
      const blob = Utils.createCsvBlob(new Csv().FromObjToCsv<Survey>(headers, content));
      Utils.createAndClickHiddenInput(URL.createObjectURL(blob), "enquêtes.csv");
    }
  }
});
